export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

/** Resolve a driver's timezone: home location → region → default. */
export const getDriverTimezone = (driver: {
  home_location?: { timezone?: string | null } | null;
  region?: { timezone?: string | null } | null;
}): string =>
  driver?.home_location?.timezone
  || driver?.region?.timezone
  || DEFAULT_TIMEZONE;

/** Resolve a rooftop's timezone from its location, falling back to default. */
export const getRooftopTimezone = (rooftop: {
  location?: { timezone?: string | null } | null;
} | null | undefined): string =>
  rooftop?.location?.timezone || DEFAULT_TIMEZONE;
